import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=36c37842&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=36c37842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c37842",
  null
  
)

export default component.exports